import { DEEP_LINK_HTTPS_HOSTS, DEEP_LINK_SCHEME } from '../../CONSTANTS';

export { DEEP_LINK_HTTPS_HOSTS, DEEP_LINK_SCHEME };

export type DeepLinkKind =
  | 'add_product'
  | 'inventory'
  | 'login'
  | 'billings'
  | 'employees'
  | 'customers'
  | 'reports'
  | 'dashboard'
  | 'home'
  | 'notifications';

export type DeepLinkAction = {
  kind: DeepLinkKind;
  href: string;
  src?: string;
  campaign?: string;
  /** Extra path segment e.g. "Sales Report" for /reports/Sales%20Report */
  param?: string;
  /** /notifications?id=… opens that notice (and what it is about). */
  notificationId?: string;
};

const PATH_KIND_MAP: Record<string, DeepLinkKind> = {
  '/inventory/new': 'add_product',
  '/inventory': 'inventory',
  '/login': 'login',
  '/billings': 'billings',
  '/employees': 'employees',
  '/employees/new': 'employees',
  '/customers': 'customers',
  '/customers/new': 'customers',
  '/dashboard': 'dashboard',
  '/notifications': 'notifications',
  '/': 'home',
};

export const resolvePathKind = (
  pathname: string,
): { kind: DeepLinkKind; param?: string } | null => {
  const exact = PATH_KIND_MAP[pathname];
  if (exact) return { kind: exact };

  if (pathname.startsWith('/reports/') || pathname === '/reports') {
    const param = decodeURIComponent(
      pathname.replace('/reports/', '').replace('/reports', ''),
    );
    return { kind: 'reports', param: param || undefined };
  }

  if (pathname.startsWith('/inventory/')) {
    return { kind: 'inventory' };
  }

  if (pathname.startsWith('/employees/')) {
    return { kind: 'employees' };
  }

  if (pathname.startsWith('/customers/')) {
    return { kind: 'customers' };
  }

  return null;
};

export const isSupportedDeepLinkHost = (host: string): boolean =>
  (DEEP_LINK_HTTPS_HOSTS as readonly string[]).includes(host.toLowerCase());
